var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "inflection-browser-table" }, [
    !_vm.view.hasPrerenderedTables
      ? _c(
          "div",
          { staticClass: "inflection-browser-table-view" },
          [
            _c("wide-table", {
              attrs: {
                collapsed: _vm.collapsed,
                view: _vm.view,
                "standard-form-data": true,
              },
            }),
            _vm._v(" "),
            _vm.view.linkedViews
              ? _vm._l(_vm.view.linkedViews, function (linkedView) {
                  return _c("wide-table", {
                    key: linkedView.id,
                    attrs: { collapsed: _vm.collapsed, view: linkedView },
                  })
                })
              : _vm._e(),
          ],
          2
        )
      : _c(
          "div",
          { staticClass: "inflection-browser-table-paradigm" },
          [
            _c("prerendered-table-wide", {
              attrs: { collapsed: _vm.collapsed, view: _vm.view },
            }),
          ],
          1
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }